/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Empty_TitleInputs */

const es_settings_dirs_empty_title = /** @type {(inputs: Settings_Dirs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin carpetas externas`)
};

const en_settings_dirs_empty_title = /** @type {(inputs: Settings_Dirs_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No external directories`)
};

/**
* | output |
* | --- |
* | "No external directories" |
*
* @param {Settings_Dirs_Empty_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_empty_title = /** @type {((inputs?: Settings_Dirs_Empty_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Empty_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_empty_title(inputs)
	return en_settings_dirs_empty_title(inputs)
});
export { settings_dirs_empty_title as "settings.dirs.empty.title" }